import { createSlice } from "@reduxjs/toolkit"
import { IProfession } from "store/apis/professionsAPI/professions.types"

interface ProfessionState {
  list: IProfession[] | []
}

const initialState: ProfessionState = {
  list: []
}

export const ProfessionsSlice = createSlice({
  name: "professions",
  initialState,
  reducers: {}
  // extraReducers: (builder) => {
  //   builder.addMatcher(
  //     getAllProfessions.matchFulfilled,
  //     (state, { payload }) => {
  //       state.list = payload as IProfession[]
  //     },
  //   )
  // },
})
